import React from 'react'

interface SpinnerProps {
  color?: string
  size?: 'sm' | 'md'
}

export const Spinner = ({ color, size = 'md' }: SpinnerProps): JSX.Element => {
  const spinnerColor = `border-${color || 'brandGreen'}`
  const sizeClasses = size === 'sm' ? 'h-4 w-4 border-2' : 'h-10 w-10 border-4'
  return (
    <div
      className={`${sizeClasses} animate-spin
        rounded-full border-solid border-t-transparent ${spinnerColor}`}
    />
  )
}
